import { USER_TYPES } from '../../../utils/constants';
import { MFA_FACTOR_IDS } from '../constants';
import { getMandatoryMFAFactorIds } from './getMandatoryMFAFactorIds';
import { isPatientWithMFASatisfied } from './patientHasSatisfiedMFA';
import { isMFARequiredInEnvironment } from './userNeedsTOTPMFASetup';

/**
 * Gets the next MFA factor that needs to be setup for the user.
 * @param {Object} params
 * @param {UserType | ""} params.userType
 * @param {import('firebase/auth').MultiFactorUser} params.multiFactorUser
 * @returns {FactorId | undefined}
 */
export const getNextMFAFactorIdNeedingSetup = ({ userType, multiFactorUser }) => {
  // Patient-specific logic: satisfied if enrolled in EITHER TOTP or SMS
  if (userType === USER_TYPES.PATIENT) {
    if (!isMFARequiredInEnvironment()) {
      return undefined;
    }

    if (isPatientWithMFASatisfied({ userType, multiFactorUser })) {
      return undefined;
    }

    // Patients who need MFA are directed to TOTP (preferred method)
    return MFA_FACTOR_IDS.TOTP;
  }

  const mandatoryFactorIds = getMandatoryMFAFactorIds({ userType });

  if (mandatoryFactorIds.length === 0) {
    return undefined;
  }

  const enrolledMethods = multiFactorUser.enrolledFactors.map((factor) => factor.factorId);

  // Get the first required method that the user is not enrolled in
  return mandatoryFactorIds.find((factorId) => !enrolledMethods.includes(factorId));
};
